<!-- 组件说明 -->
<template>
  <div class="adviser-all">
    <div class="adviser-list">
      <div
        v-for="(item, index) in adviserList"
        :key="index"
        @click="selectAdviser(item)"
        :class="[
          'adviser',
          dataList.indexOf(item.managerCode) > -1 ? 'isSelect' : '',
        ]"
      >
        {{ item.managerName }}
      </div>
    </div>
    <div class="btn-group">
      <div class="btn" style="color:#999999" @click="cancel">取消</div>
      <div class="line"></div>
      <div class="btn" style="color:#0D9869" @click="submit">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    adviserList: {
      type: Array,
    },
    adviserCode: {
      type: Array,
    },
  },
  data() {
    return {
      dataList: [""],
    };
  },
  created() {
    this.initData();
  },
  computed: {},
  methods: {
    selectAdviser(adviser) {
      if (adviser.managerCode === "") {
        this.dataList = [""];
      } else {
        if (this.dataList[0] === "") {
          this.dataList = [];
        }
        if (this.dataList.indexOf(adviser.managerCode) !== -1) {
          this.dataList.splice(this.dataList.indexOf(adviser.managerCode), 1);
          // console.log(this.dataList, "DATALIST");
          // 如果选项为空则默认为全部
          if (!this.dataList.length) {
            this.dataList = [""];
          }
        } else {
          this.dataList.push(adviser.managerCode);
        }
      }
    },
    submit() {
      this.$emit("changeAdvisers", this.dataList);
    },
    cancel() {
      this.$emit("cancelAdviser");
    },
    initData() {
      this.dataList = [...this.adviserCode];
    },
  },
};
</script>

<style lang="scss" scoped>
.adviser-list {
  display: flex;
  flex-wrap: wrap;
  padding: 40px 30px 0;
  height: 376px;
  overflow-y: scroll;
  :nth-child(3n-1) {
    margin: 0 16px;
  }
  .adviser {
    width: 216px;
    height: 88px;
    background: #f3f3f3;
    border-radius: 12px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #575757;
    line-height: 88px;
    text-align: center;
    margin-bottom: 24px;
    &.isSelect {
      background: #0d9869;
      color: #ffffff;
    }
  }
}
.btn-group {
  width: 750px;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 0px 0px rgba(242, 242, 242, 1);
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  .btn {
    width: 374px;
    text-align: center;
  }
  .line {
    width: 2px;
    height: 60px;
    background: #eaeaea;
    border-radius: 1px;
  }
}
</style>
